module.exports = __webpack_public_path__ + "static/media/walletQuestion.8887124c.PNG";